import './App.css';
import './fonts.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { createTheme } from '@mui/material';
import { ThemeProvider } from '@mui/system';
import AuthWrapper from './components/AuthWrapper';
import LoginPage from './pages/LoginPage';
import ReviewPage from './pages/ReviewPage';
import LogoutPage from './pages/LogoutPage';
import NewRenderPage from './pages/NewRenderPage';
import RendersListPage from './pages/RendersListPage';
import ProjectionsPage from './pages/ProjectionsPage';
import ProjectionsListPage from './pages/ProjectionsListPage';
import RenderProjectionsPage from './pages/RenderProjectionsPage';
import AndroidViewer from './pages/AndroidViewer';
import CopyPage from './pages/CopyPage';
import CopyPomPage from './pages/CopyPomPage';
import DeletePage from './pages/DeletePage';
import RetailerPage from './pages/RetailerPage';
import UploadCsvPage from './pages/UploadCsvPage';
import SearchPage from './pages/SearchPage';
import RerenderProjections from './pages/RerenderProjections';
import CopyRetailerProjections from './pages/CopyRetailerProjections';
import PomListPage from './pages/PomListPage';
import VideoUploadPage from './pages/VideoUploadPage';
import TGAImagesUploadPage from './pages/TGAImagesUploadPage';
import PomScenesToolPage from './pages/PomScenesToolPage';
import PomSceneEditPage from './pages/PomSceneEditPage';
import PomSceneAddPage from './pages/PomSceneAddPage';
import ProductCSVApprovePage from './features/productsCSVApprove/ProductCSVApprovePage';


const theme = createTheme({
  palette: {
    primary: {
      main: '#2F6BD5',
    },
    secondary: {
      main: '#dc004e',
    },
  },
  typography: {
    button: {
      textTransform: 'none'
    },
    fontFamily: [
      'Open Sans',
    ].join(','),

    infoKey: {
      fontFamily: 'Montserrat',
      fontWeight: 400,
      color: "#A3A3A3"
    },

    infoValue: {
      fontFamily: 'Open Sans',
      fontWeight: 500,
      color: "#2E2E2E"
    }


  },
  mixins: {
    toolbar: {
      minHeight: 30,
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>

      <Router>
        <Routes>
          <Route path="/review" element={
            <AuthWrapper element={<ReviewPage />} />
          } />
          <Route path="/login" element={
            <LoginPage />
          } />
          <Route path="/logout" element={
            <LogoutPage />
          } />
          <Route path="/new" element={
            <AuthWrapper element={<NewRenderPage />} />}
          />
          <Route path="/list" element={
            <AuthWrapper element={<RendersListPage />} />}
          />
          <Route path="/projections/:id" element={
            <AuthWrapper element={<ProjectionsPage />} />}
          />
          <Route path="/projections/" element={
            <AuthWrapper element={<ProjectionsListPage />} />}
          />
          <Route path="/render_projections/:sessionId" element={
            <AuthWrapper element={<RenderProjectionsPage />} />}
          />
          <Route path="/android_viewer/:glb" element={
            <AndroidViewer />
          } />

          <Route path="/copy" element={
            <AuthWrapper element={<CopyPage />} />}
          />

          <Route path="/copy-pom" element={
            <AuthWrapper element={<CopyPomPage />} />}
          />

          <Route path="/delete" element={
            <AuthWrapper element={<DeletePage />} />}
          />
          <Route path="/retailer/:retailer" element={
            <AuthWrapper element={<RetailerPage />} />}
          />
          <Route path="/upload-csv/" element={
            <AuthWrapper element={<UploadCsvPage />} />}
          />

          <Route path="/search" element={
            <AuthWrapper element={<SearchPage />} />}
          />

          <Route path="/copy-retailer/" element={
            <AuthWrapper element={<CopyRetailerProjections />} />}
          />
          <Route path="/rerender/" element={
            <AuthWrapper element={<RerenderProjections />} />}
          />
          <Route path="/pom/" element={
            <AuthWrapper element={<PomListPage />} />}
          />
          <Route path="/video-upload/" element={
            <AuthWrapper element={<VideoUploadPage />} />}
          />
          <Route path="/tga-upload/" element={
            <AuthWrapper element={<TGAImagesUploadPage />} />}
          />
          <Route path="/pom-scenes/" element={
            <AuthWrapper element={<PomScenesToolPage />} />}
          />
          <Route path="/pom-scenes/edit" element={
            <AuthWrapper element={<PomSceneEditPage />} />}
          />
          <Route path="/pom-scenes/add" element={
            <AuthWrapper element={<PomSceneAddPage />} />}
          />
          <Route
            path="/products/approve-csv"
            element={<AuthWrapper element={<ProductCSVApprovePage />} />}
          />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
